import { LitElement, html, css } from 'lit'
import { customElement, state } from 'lit/decorators.js'

@customElement('app-root')
export class AppRoot extends LitElement {
  static styles = css`
    :host {
      display: block;
      min-height: 100vh;
    }
  `

  @state()
  private currentPath = window.location.pathname

  connectedCallback() {
    super.connectedCallback()
    // Listen for route changes (e.g., back/forward buttons)
    window.addEventListener('popstate', this.handleRouteChange)
    this.handleRouteChange()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('popstate', this.handleRouteChange)
  }

  private handleRouteChange = () => {
    this.currentPath = window.location.pathname
  }

  render() {
    // Simple routing based on pathname
    if (this.currentPath === '/health') {
      return html`<health-page></health-page>`
    }
    
    // Default to hello-world-app for root and other paths
    return html`<hello-world-app></hello-world-app>`
  }
}
